import React, { useState, useRef } from "react";

import Modal from "react-bootstrap/Modal";
import "./sale_person.css";

import TextField from "@mui/material/TextField";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import Red_toast from "../alerts/red_toast";
import success_toast from "../alerts/success_toast";
import Save_button from "../buttons/save_button";
import { useTranslation } from "react-i18next";

function Sale_personform({
  show,
  onHide,
  user,
  route,
  callback,
  selected_branch,
}) {
  const { t } = useTranslation();
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [contact, setcontact] = useState("");

  const [address, setaddress] = useState("");
  const [isloading, setisloading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selected_branch) {
      setisloading(true);
      const formData = new FormData();

      formData.append("name", name);
      formData.append("contact", contact);
      formData.append("email", email);

      formData.append("address", address);
      formData.append("branch", selected_branch.id);

      formData.append("type", "sale_person");

      const response = await fetch(`${route}/api/salespersons/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${user.access}`,
        },
        body: formData,
      });
      const json = await response.json();

      if (!response.ok) {
        setisloading(false);
        if (json.code === "token_not_valid") {
          callback({ type: "token_not_valid", data: null });
          return;
        }
        var error = Object.keys(json);
        if (error.length > 0) {
          Red_toast(`${json[error[0]]}`);
        }
      }

      if (response.ok) {
        callback({ type: "Create_table_history", data: json });
        setisloading(false);
        success_toast();
        setname("");
        setcontact("");
        setemail("");

        setaddress("");
      }
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      style={{ zoom: ".8" }}
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="d-flex align-items-md-center"
        >
          <FontAwesomeIcon className="me-2" icon={faUserPlus} />{" "}
          {t("add_saleperson")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!selected_branch && (
          <div className="text-center text-danger mb-2">
            Please Select Branch!
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="col-md-12">
            <TextField
              className="form-control   mb-3"
              id="outlined-basic"
              label={t("name")}
              value={name}
              onChange={(e) => {
                setname(e.target.value);
              }}
              size="small"
              required
            />
            <TextField
              type="email"
              className="form-control   mb-3"
              id="outlined-basic"
              label={t("email")}
              value={email}
              onChange={(e) => {
                setemail(e.target.value);
              }}
              size="small"
            />

            <TextField
              className="form-control  mb-3"
              id="outlined-basic"
              label={t("phone")}
              value={contact}
              onChange={(e) => {
                setcontact(e.target.value);
              }}
              size="small"
            />

            <TextField
              multiline
              className="form-control  mb-3"
              id="outlined-basic"
              label={t("address")}
              value={address}
              onChange={(e) => {
                setaddress(e.target.value);
              }}
              size="small"
            />
          </div>

          <hr></hr>
          <div className=" d-flex flex-row-reverse mt-2 me-2">
            <Save_button isloading={isloading} />
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default Sale_personform;
